/**
 * Class Priority Utils
 * Priority: AfterSchool (安親) > English (英文) > Talent (才藝) > Others
 */

const DEPARTMENT_PRIORITY = {
    'AfterSchool': 1,
    '全科班': 1,
    'English': 2,
    '英文部': 2,
    'Talent': 3,
    '才藝部': 3
};

/**
 * Get priority score (Lower is better)
 */
export const getDepartmentPriority = (deptName) => {
    if (!deptName) return 99;
    return DEPARTMENT_PRIORITY[deptName] || 99;
};

/**
 * Sort classes array by priority
 */
export const sortClasses = (classes) => {
    if (!Array.isArray(classes)) return [];
    return [...classes].sort((a, b) => {
        return getDepartmentPriority(a.department) - getDepartmentPriority(b.department);
    });
};

/**
 * Get the primary class name for display
 * Logic:
 * 1. If student has 'classes' (array), sort them and pick first.
 * 2. If student has 'class' (object), use it (legacy/single).
 * 3. Fallback to 'Unassigned'.
 */
export const getPrimaryClass = (student) => {
    if (!student) return null;

    // V2: Multiple Classes
    if (student.classes && Array.isArray(student.classes) && student.classes.length > 0) {
        const sorted = sortClasses(student.classes);
        return sorted[0];
    }

    // V1: Single Class properties
    if (student.class) return student.class;

    // Fallback if flat properties exist
    if (student.class_name) return { name: student.class_name, department: student.department };

    return null;
};

/**
 * Get formatted primary class name string
 */
export const getPrimaryClassName = (student) => {
    const cls = getPrimaryClass(student);
    return cls ? cls.name : '未分班';
};

/*
 * 曾經在這裡的 `classesOfStudent(student)`（回傳一位學生掛的所有班）已於 2026-08-19 移除。
 *
 * 它只有親師對話的兩個名冊在用，用途是「把還沒有對話的學生對到可以開對話的班」。
 * 但它算的是「該生的**全部**班級」，而真正該用的是「**這位呼叫者開得起來的**班級」——
 * 兩者對帶班老師剛好相同，對管理員/超管則不同（機構界線、沒有主班的學生）。
 * 現在由後端 `GET /chat/roster` 直接回傳每位學生的可開班級清單，前端不再自行推導權限。
 */
